<template>
  <div
    style="
      margin: 0 !important;
      padding: 0 !important;
      overflow-x: hidden !important;
    "
  >
    <logged-in-bar />
    <h1>Renters Insurance by National Student Services, Inc. (NSSI)</h1>
    <home-hero />
    <coverage-info />
    <renters-intro />
    <my-video />
    <home-deductible />
    <home-customize />
    <accidental-damage />
    <home-ending />
    <home-footer />
  </div>
</template>

<script lang="ts" setup>
import AccidentalDamage from "@/views/partials/AccidentalDamage.vue";
import HomeFooter from "@/views/partials/HomeFooter.vue";
import CoverageInfo from "@/views/partials/CoverageInfo.vue";
import RentersIntro from "@/views/partials/RentesIntro.vue";
import HomeDeductible from "@/views/partials/HomeDeductible.vue";
import HomeCustomize from "@/views/partials/HomeCustomize.vue";
import HomeEnding from "@/views/partials/HomeEnding.vue";
import HomeHero from "@/views/partials/HomeHero.vue";
import MyVideo from "@/views/partials/MyVideo.vue";
import LoggedInBar from "@/views/partials/LoggedInBar.vue";
// AOS library
import AOS from "aos";
import "aos/dist/aos.css";

import { InsuranceAddress } from "@/models/InsuranceAddress";
import { QuoteInfo } from "@/models/QuoteInfo";
import { QuoteInsurance } from "@/models/QuoteInsurance";
import { Checkout } from "@/models/Checkout";
import { Defaults } from "@/models/Defaults";

import ModalNames from "@/utils/ModalNames";
import { onBeforeMount, onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";

const userStore = useUserStore();
const route = useRoute();
const router = useRouter();
const quote = useQuoteStore();

const accidentalDamageModal = ref();

function showModal(args: any[]) {
  let modal = undefined;
  switch (String(args)) {
    case ModalNames.ACCIDENTAL_DAMAGE_MODAL:
      modal = accidentalDamageModal.value as any;
  }
  if (modal) {
    modal.show();
  }
}
onBeforeMount(() => {
  if (!sessionStorage.getItem("log")) {
    userStore.logout();
    quote.clearQuote();
    localStorage.removeItem("quoteStore");
    sessionStorage.setItem("log", "true");
  }
});
onMounted(async () => {
  AOS.init();
  // if (quote && quote.done) {
  //   quote.address = new InsuranceAddress();
  //   quote.info = new QuoteInfo();
  //   quote.rentersInsurance = new QuoteInsurance();
  //   quote.personalInsurance = new QuoteInsurance();
  //   quote.hasPersonalInsurance = true;
  //   quote.checkout = new Checkout();
  //   quote.processingFee = Defaults.getInstance().processingFee;
  //   quote.done = false;
  //   quote.nssiPassed = false;
  //   quote.assurantPassed = false;
  //   quote.assurantToken = "";
  //   quote.assurantExpirationTime = "";
  //   quote.currentStep = "";
  //   quote.nssiPolicyError = "";
  //   quote.assurantPolicyError = "";
  //   quote.folowUpMailSent = false;
  // }

  if (route.query) {
    if (route.query.page) {
      showModal(route.query.page as any);
      // Should we remove query params? ALl of them? Or just the page one?
      router.replace({ query: undefined });
    }
  }
});
</script>
